module.exports = __webpack_public_path__ + "img/title_sp.8b809181.svg";